import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["children"],
  _excluded2 = ["children", "showShadow"],
  _excluded3 = ["children", "showShadow"],
  _excluded4 = ["children"],
  _excluded5 = ["children"],
  _excluded6 = ["children"],
  _excluded7 = ["children"],
  _excluded8 = ["children"],
  _excluded9 = ["children"],
  _excluded0 = ["children"];
import { Box, Button, Heading } from '@wix/design-system';
import { DomainSearchSuiteModule, SearchRecommendationLayout } from '@wix/domains-search-suite';
import React from 'react';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import s from '../common.scss';
import styles from './PreSuggestions.scss';
import { usePreSuggestions } from '../../hooks/usePreSuggestions';
import { PRE_SUGGESTIONS_FALLBACK_QUERY } from '../../hooks/usePreSuggestionsQuery';
import { LazyRecommendationLabel } from '../LazyRecommedationLabel/LazyRecommendationLabel';
import { useIsHarmonyTheme, useIsMobile } from '@wix/core-domain-search';
const SearchRecommendationSharedProps = {
  direction: 'vertical',
  minHeight: '183px',
  height: '100%',
  align: 'space-between',
  gap: '46px',
  padding: '20px',
  borderRadius: '12px',
  border: '1px solid #DEDEDE'
};
const harmonyCardProps = {
  border: 'none',
  backgroundColor: 'var(--wds-color-fill-surface-raised, #FFFFFF)',
  boxShadow: 'var(--wds-card-base-shadow, none)'
};
const cardShadowProps = {
  boxShadow: 'var(--wds-shadow-300)'
};
const domainInfoProps = {
  direction: 'vertical',
  gap: 'SP2',
  margin: '8px 0'
};
const SearchRecommendationListContainer = _ref => {
  let children = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const isMobile = useIsMobile();
  return /*#__PURE__*/React.createElement(Box, _extends({
    direction: isMobile ? 'vertical' : 'horizontal',
    display: "flex",
    width: "100%",
    flex: 1,
    gap: "SP4",
    align: "space-between",
    flexWrap: "wrap"
  }, props), children);
};
const RecommendationCard = _ref2 => {
  let children = _ref2.children,
    _ref2$showShadow = _ref2.showShadow,
    showShadow = _ref2$showShadow === void 0 ? false : _ref2$showShadow,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  const isMobile = useIsMobile();
  const isHarmonyTheme = useIsHarmonyTheme();
  return /*#__PURE__*/React.createElement(Box, _extends({}, SearchRecommendationSharedProps, isMobile && {
    minHeight: 'auto',
    gap: '16px'
  }, props, isHarmonyTheme && harmonyCardProps, showShadow && cardShadowProps), children);
};
const RecommendationSkeletonCard = _ref3 => {
  let children = _ref3.children,
    _ref3$showShadow = _ref3.showShadow,
    showShadow = _ref3$showShadow === void 0 ? false : _ref3$showShadow,
    props = _objectWithoutPropertiesLoose(_ref3, _excluded3);
  const isHarmonyTheme = useIsHarmonyTheme();
  return /*#__PURE__*/React.createElement(Box, _extends({}, SearchRecommendationSharedProps, props, isHarmonyTheme && harmonyCardProps, showShadow && cardShadowProps), children);
};
export const PreSuggestionLayout = {
  SearchRecommendationListContainer: props => /*#__PURE__*/React.createElement(SearchRecommendationListContainer, props),
  SearchRecommendationContainer: props => /*#__PURE__*/React.createElement(RecommendationCard, props),
  SearchRecommendationSkeletonContainer: props => /*#__PURE__*/React.createElement(RecommendationSkeletonCard, props),
  DomainInfoContainer: _ref4 => {
    let children = _ref4.children,
      props = _objectWithoutPropertiesLoose(_ref4, _excluded4);
    return /*#__PURE__*/React.createElement(Box, _extends({}, domainInfoProps, props), children);
  },
  Skeleton: () => /*#__PURE__*/React.createElement(SearchRecommendationLayout.Skeleton, {
    limit: 3
  }),
  GetItButtonContainer: _ref5 => {
    let children = _ref5.children,
      props = _objectWithoutPropertiesLoose(_ref5, _excluded5);
    return /*#__PURE__*/React.createElement(Box, _extends({
      flex: 1,
      align: "right"
    }, props), children);
  },
  GetItButton: _ref6 => {
    let children = _ref6.children,
      props = _objectWithoutPropertiesLoose(_ref6, _excluded6);
    return /*#__PURE__*/React.createElement(Button, _extends({
      size: "medium",
      skin: "dark"
    }, props, {
      priority: "primary"
    }), children);
  },
  TitleDisplay: _ref7 => {
    let children = _ref7.children,
      props = _objectWithoutPropertiesLoose(_ref7, _excluded7);
    return /*#__PURE__*/React.createElement(Heading, {
      size: "large",
      className: styles.domainTitle
    }, props.title);
  },
  Divider: () => /*#__PURE__*/React.createElement(React.Fragment, null),
  HoverBox: _ref8 => {
    let children = _ref8.children,
      props = _objectWithoutPropertiesLoose(_ref8, _excluded8);
    return /*#__PURE__*/React.createElement(Box, _extends({}, props, {
      flex: 1,
      className: ""
    }), children);
  },
  ActionsContainer: _ref9 => {
    let children = _ref9.children,
      props = _objectWithoutPropertiesLoose(_ref9, _excluded9);
    return /*#__PURE__*/React.createElement(Box, _extends({
      gap: "SP4",
      verticalAlign: "middle",
      align: "space-between"
    }, props), children);
  },
  PricingWrapper: _ref0 => {
    let children = _ref0.children,
      props = _objectWithoutPropertiesLoose(_ref0, _excluded0);
    return /*#__PURE__*/React.createElement(Box, _extends({}, props, {
      align: "left",
      className: styles.pricing
    }), children);
  }
};
const ShadowedPreSuggestionLayout = {
  ...PreSuggestionLayout,
  SearchRecommendationContainer: props => /*#__PURE__*/React.createElement(RecommendationCard, _extends({}, props, {
    showShadow: true
  })),
  SearchRecommendationSkeletonContainer: props => /*#__PURE__*/React.createElement(RecommendationSkeletonCard, _extends({}, props, {
    showShadow: true
  }))
};
export const PreSuggestions = _ref1 => {
  let _ref1$fallbackQuery = _ref1.fallbackQuery,
    fallbackQuery = _ref1$fallbackQuery === void 0 ? PRE_SUGGESTIONS_FALLBACK_QUERY : _ref1$fallbackQuery,
    _ref1$showCardShadow = _ref1.showCardShadow,
    showCardShadow = _ref1$showCardShadow === void 0 ? false : _ref1$showCardShadow;
  const _usePreSuggestions = usePreSuggestions(fallbackQuery),
    recommendations = _usePreSuggestions.recommendations,
    isLoading = _usePreSuggestions.isLoading,
    isPricingLoading = _usePreSuggestions.isPricingLoading,
    matchLabels = _usePreSuggestions.matchLabels,
    isLoadingLabels = _usePreSuggestions.isLoadingLabels,
    disabled = _usePreSuggestions.disabled,
    hidden = _usePreSuggestions.hidden,
    onGetItClick = _usePreSuggestions.onGetItClick;
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t;
  if (hidden) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP7",
    width: "100%",
    align: "center",
    padding: "SP4 0 SP10 0"
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "large",
    className: s.sectionTitle
  }, t('domain_search_gate.domain_gate.suggestions.header')), /*#__PURE__*/React.createElement(DomainSearchSuiteModule.SDK.Components.SearchRecommendationList, {
    items: recommendations,
    reportImpressions: true,
    isLoading: isLoading,
    isPricingLoading: isPricingLoading,
    Layouts: {
      ...(showCardShadow ? ShadowedPreSuggestionLayout : PreSuggestionLayout),
      LabelContainer: LazyRecommendationLabel({
        isLoading: isLoadingLabels,
        matchLabels
      })
    },
    disabled: disabled,
    onClickGetIt: onGetItClick,
    firstSuggestionPrimary: false
  }));
};
//# sourceMappingURL=PreSuggestions.js.map